// @flow
import * as React from 'react';
import AuthEuCookieBar from 'app/common/react/components/AuthEuCookieBar/AuthEuCookieBar';
import Experience from 'app/common/react/components/experiences/Experience/Experience';

type PropType = { placementId: number };

const ExperienceAuthEuCookieBar = ({ placementId }: PropType) => (
  <Experience
    experienceIds={[PCONST.thrift.Experience.WEB_EU_COOKIE_BANNER]}
    placementId={placementId}
  >
    {({ complete }) => <AuthEuCookieBar onGotItClick={complete} />}
  </Experience>
);

export default ExperienceAuthEuCookieBar;
